/**
 * orga-app-api - qschecks-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PruefplanDetail { 
    beschreibung?: string;
    funktionsbereich_id: string;
    pruefplan_id: string;
    titel?: string;
    ist_aktiv?: boolean;
    zaehler_pro_veranstaltungstyp?: boolean;
    mandant_id?: string;
    modified_on_utc?: Date;
}

